// @flow
if (typeof window.htmlUtils === 'undefined') {
  window.htmlUtils = {
    stopPropagation: event => event.stopPropagation(),
  };
}



// WEBPACK FOOTER //
// ../globals/htmlUtils.js